<template>
	<div class="seller">
		<form class="seller__register" @submit.prevent="addSeller">
			<table class="simple-table">
				<thead>
					<tr>
						<th>판매처명</th>
						<th>등록</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<input
								type="text"
								class="input-text"
								placeholder="판매처명을 입력하세요"
								v-model="brandCategoryText"
							/>
						</td>
						<td class="seller__register-btn">
							<button class="btn blue" type="submit">등록</button>
						</td>
					</tr>
				</tbody>
			</table>
		</form>
		<ManagingSection :isTable="true">
			<table class="table-main">
				<thead>
					<tr>
						<th>항번</th>
						<th>판매처명</th>
						<th>신규 이미지</th>
						<th>활성화 여부</th>
						<th>수정</th>
						<th>삭제</th>
					</tr>
				</thead>
				<Draggable
					tag="tbody"
					group="list"
					:list="list"
					@end="onDragEnd"
				>
					<tr v-for="list in list" :key="list.idBrandType">
						<td>
							{{ list.idBrandType }}
						</td>
						<td>
							<input
								type="text"
								class="input-text"
								placeholder="판매처명"
								v-model="list.brandTypeName"
							/>
						</td>
						<td>
							<div class="seller__image" v-if="list.newFileDir">
								<ImageExif
									:src="`${imageHost}${list.newFileDir}/${list.newFileSaveName}`"
								/>
							</div>
							<input
								type="file"
								placeholder="신규 이미지"
								ref="sellerImage"
								@change="
									handleFileChange($event, list.idBrandType)
								"
							/>
						</td>
						<td>
							<RadioList
								class="radio-box__input"
								:radioList="radioList"
								v-model="list.isDisplay"
								keyName="id"
								valueName="value"
							/>
						</td>
						<td>
							<button
								class="btn blue"
								@click="modifySeller(list.idBrandType)"
							>
								수정
							</button>
						</td>
						<td>
							<button
								class="btn red"
								@click="deleteSeller(list.idBrandType)"
							>
								삭제
							</button>
						</td>
					</tr>
				</Draggable>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import RadioList from '../RadioList.vue';
	import ImageExif from '../ImageExif.vue';
	import { imageUpload } from '@/util';
	import Draggable from 'vuedraggable';
	import ManagingSection from '@/components/layout/ManagingSection.vue';

	export default {
		components: {
			RadioList,
			ImageExif,
			Draggable,
			ManagingSection,
		},
		data() {
			return {
				radioList: [
					{ id: 'Y', value: '예' },
					{ id: 'N', value: '아니오' },
				],
				list: [],
				brandCategoryText: '',
				orderNum: null,
				originalList: [],
			};
		},
		created() {
			this.getList();
		},
		computed: {
			imageHost: {
				get() {
					return this.$store.state.env.IMAGE_STORAGE_PATH;
				},
			},
		},
		methods: {
			async getList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						'/api/brands/brandTypeList'
					);
					const listLength = data.data.length;

					this.list = data.data.map((item, index) => {
						return {
							...item,
						};
					});
					this.originalList = [...this.list];
				} catch (error) {
					console.error(error);
				}
			},
			async addSeller() {
				try {
					const params = {
						isDisplay: 'Y',
						brandTypeName: this.brandCategoryText,
						priceGap: '0',
						orderNum: this.list.length + 1,
					};
					await this.$axiosAdmin2.post(
						'/api/brands/brandType',
						params
					);
					alert('등록되었습니다.');
					this.brandCategoryText = '';
					this.getList();
				} catch (error) {
					console.log(error);
					alert(
						'등록에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			async deleteSeller(idBrandType) {
				try {
					if (!confirm('정말 삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(
						`/api/brands/brandType/${idBrandType}`
					);
					alert('삭제되었습니다.');
					this.getList();
				} catch (error) {
					console.log(error);
					alert(
						'삭제에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			async uploadImage(imageObj, idBrandType) {
				const { extension, fileObject } = imageObj;

				try {
					const res = await imageUpload(
						extension,
						'brand-cate-img',
						fileObject
					);
					const filePath = `/${res.config.data.get('key')}`;
					const fileSaveName = filePath.split('/').pop();
					const imgPath = filePath.replace(/\/[^/]+\/?$/, '');

					const sellerIndex = this.list.findIndex(
						seller => seller.idBrandType === idBrandType
					);
					if (sellerIndex !== -1) {
						this.$set(
							this.list[sellerIndex],
							'newFileDir',
							imgPath
						);
						this.$set(
							this.list[sellerIndex],
							'newFileSaveName',
							fileSaveName
						);
					}
				} catch (err) {
					console.error(err);
				}
			},
			async handleFileChange(event, idBrandType) {
				const files = [...event.target.files];
				const readFileList = await Promise.all(
					files.map(file => this.readFile(file))
				);
				const urlList = readFileList.map(({ target }) => target.result);
				this.addImg(urlList, files, idBrandType);
			},
			addImg(urlList, files, idBrandType) {
				const list = urlList.map((url, idx) => {
					const srcObj = {
						src: url,
						fileObject: files[idx],
						extension: files[idx].type.split('/').pop(),
					};
					return srcObj;
				});
				this.uploadImage(list[0], idBrandType);
			},
			readFile(file) {
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.onload = e => {
						const img = new Image();
						img.src = e.target.result;
						img.onload = () => {
							resolve(e);
						};
					};
					reader.readAsDataURL(file);
				});
			},
			async modifySeller(id) {
				try {
					if (!confirm('정말 수정하시겠습니까?')) return;
					const params = {
						...this.list.find(item => item.idBrandType === id),
					};
					await this.$axiosAdmin2.post(
						`/api/brands/brandType`,
						params
					);
					alert('수정되었습니다.');
					this.getList();
				} catch (error) {
					console.log(error);
					alert(
						'수정에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			async onDragEnd(event) {
				try {
					const changedItems = this.list.map((item, index) => {
						return {
							idBrandType: item.idBrandType,
							orderNum: this.list.length - index,
						};
					});
					const originalList = this.originalList.map(
						(item, index) => {
							return {
								idBrandType: item.idBrandType,
								orderNum: this.originalList.length - index,
							};
						}
					);

					const changedItemList = changedItems
						.filter(item1 => {
							const matchingItem = originalList.find(
								item2 => item2.idBrandType === item1.idBrandType
							);
							return (
								matchingItem &&
								item1.orderNum !== matchingItem.orderNum
							);
						})
						.map(item => ({
							idBrandType: item.idBrandType,
							orderNum: item.orderNum,
						}));

					if (changedItems.length > 0) {
						await this.$axiosAdmin2.put(
							'/api/brands/brandType/order',
							changedItemList
						);
						this.getList();
					} else {
						console.log('변경된 항목이 없습니다.');
					}
				} catch (error) {
					console.log(error);
					alert(
						'순서 변경에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.seller {
		&__image {
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0 auto 20px;
			width: 250px;
			border: 1px solid #ddd;
		}
		&__register {
			width: 60%;
			margin: 50px auto 100px;
			.simple-table {
				th {
					background: linear-gradient(
						to top,
						#d3e1f1,
						#f4f7fa,
						#f4f7fa
					);
					border: solid 1px #d5dde6;
					text-align: center;
					padding: 0;
				}
				td {
					text-align: center;
				}
			}
		}
		&__register-btn {
			width: 1%;
		}
	}
</style>
